module.exports = __webpack_public_path__ + "static/img/ud-logo.af47e64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/ud-logo.png
// module id = tz7Z
// module chunks = 0